(function () {
    let galerieLightboxEl = null;
    let galerieSavedScrollY = 0;
    let galerieLightboxTriggerEl = null;
    let galerieLightboxCount = 0;
    let galerieProgressBar = null;
    let galerieHideTimeout = null;

    function preventGalerieLightboxTouch(e) {
        if (e.target.closest('.galerieLightboxViewer')) {
            return;
        }
        e.preventDefault();
    }

    function lhm_getGalerieLightboxActiveIndex(track) {
        const slides = Array.from(track.children);
        const scrollLeft = track.scrollLeft;
        let activeIndex = 0;

        slides.forEach((slide, i) => {
            if (slide.offsetLeft <= scrollLeft + 1) {
                activeIndex = i;
            }
        });

        return activeIndex;
    }

    function lhm_updateGalerieLightboxNav() {
        const lightbox = galerieLightboxEl;
        const track = lightbox.querySelector('.galerieLightboxTrack');
        const status = lightbox.querySelector('.galerieLightboxStatus');
        const progress = lightbox.querySelector('.progressBar');
        const activeIndex = lhm_getGalerieLightboxActiveIndex(track);

        status.textContent = `Bild ${activeIndex + 1} von ${galerieLightboxCount}`;

        if (progress) {
            progress.classList.toggle('progressBar-visible', galerieLightboxCount > 1);
        }

        if (galerieProgressBar) {
            galerieProgressBar.update();
        }
    }

    function lhm_goToGalerieLightboxSlide(index) {
        const track = galerieLightboxEl.querySelector('.galerieLightboxTrack');
        const slide = track.children[index];

        if (slide) {
            track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
    }

    function lhm_stepGalerieLightbox(direction) {
        const track = galerieLightboxEl.querySelector('.galerieLightboxTrack');
        const activeIndex = lhm_getGalerieLightboxActiveIndex(track);
        lhm_goToGalerieLightboxSlide(activeIndex + direction);
    }

    function getGalerieLightboxEl() {
        if (galerieLightboxEl) {
            return galerieLightboxEl;
        }

        const lightbox = document.createElement('div');
        lightbox.className = 'galerieLightbox';
        lightbox.hidden = true;
        lightbox.setAttribute('role', 'dialog');
        lightbox.setAttribute('aria-modal', 'true');
        lightbox.setAttribute('aria-label', 'Bildergalerie');
        lightbox.innerHTML = `
            <button type="button" class="galerieLightboxClose" aria-label="Schließen"></button>
            <div class="galerieLightboxViewer" role="group" aria-roledescription="Karussell">
                <div class="galerieLightboxTrack"></div>
            </div>
            <div class="progressBar" role="slider" tabindex="0" aria-label="Bildergalerie" aria-valuemin="1" aria-valuemax="1" aria-valuenow="1">
                <div class="progressBarFill"></div>
            </div>
            <div class="galerieLightboxStatus screen-reader-text" aria-live="polite" aria-atomic="true"></div>
        `;
        document.body.appendChild(lightbox);

        galerieProgressBar = window.lhm_initProgressBar(lightbox.querySelector('.progressBar'), {
            getItems: () => Array.from(lightbox.querySelector('.galerieLightboxTrack').children),
            getActiveIndex: () => lhm_getGalerieLightboxActiveIndex(lightbox.querySelector('.galerieLightboxTrack')),
            scrollToItem: (item) => {
                lightbox.querySelector('.galerieLightboxTrack').scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
            },
            stepItem: lhm_stepGalerieLightbox,
        });

        lightbox.querySelector('.galerieLightboxClose').addEventListener('click', closeGalerieLightbox);
        lightbox.addEventListener('click', (e) => {
            if (e.target.closest('img, button, .progressBar')) {
                return;
            }
            closeGalerieLightbox();
        });

        let scrollTicking = false;
        lightbox.querySelector('.galerieLightboxTrack').addEventListener('scroll', () => {
            if (!scrollTicking) {
                scrollTicking = true;
                requestAnimationFrame(() => {
                    lhm_updateGalerieLightboxNav();
                    scrollTicking = false;
                });
            }
        }, { passive: true });

        galerieLightboxEl = lightbox;

        return lightbox;
    }

    function openGalerieLightbox(triggers, initialIndex, triggerEl) {
        const lightbox = getGalerieLightboxEl();
        const track = lightbox.querySelector('.galerieLightboxTrack');

        clearTimeout(galerieHideTimeout);
        galerieLightboxCount = triggers.length;

        track.innerHTML = triggers
            .map((trigger, index) => {
                const src = trigger.dataset.lightboxSrc;
                const alt = trigger.dataset.lightboxAlt || '';
                const label = `Bild ${index + 1} von ${triggers.length}`;
                return `<div class="galerieLightboxSlide" role="group" aria-roledescription="Folie" aria-label="${label}"><img src="${src}" alt="${alt}"></div>`;
            })
            .join('');

        galerieLightboxTriggerEl = triggerEl || document.activeElement;

        galerieSavedScrollY = window.scrollY;
        lightbox.hidden = false;
        requestAnimationFrame(() => {
            lightbox.classList.add('galerieLightbox-open');
        });
        document.documentElement.style.setProperty('--scrollbar-width-lockscroll', `${window.innerWidth - document.documentElement.clientWidth}px`);
        document.body.classList.add('lockScroll');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${galerieSavedScrollY}px`;
        document.body.style.width = '100%';
        document.addEventListener('touchmove', preventGalerieLightboxTouch, { passive: false });
        document.addEventListener('keydown', handleGalerieLightboxKeydown);

        const page = document.getElementById('page');
        if (page) {
            page.inert = true;
        }

        track.scrollTo({ left: 0, behavior: 'auto' });
        const initialSlide = track.children[initialIndex];
        if (initialSlide) {
            track.scrollTo({ left: initialSlide.offsetLeft, behavior: 'auto' });
        }
        lhm_updateGalerieLightboxNav();

        lightbox.querySelector('.galerieLightboxClose').focus();
    }

    function closeGalerieLightbox() {
        if (!galerieLightboxEl || galerieLightboxEl.hidden) {
            return;
        }

        galerieLightboxEl.classList.remove('galerieLightbox-open');

        clearTimeout(galerieHideTimeout);
        galerieHideTimeout = setTimeout(hideLightboxEl, 300);
        galerieLightboxEl.addEventListener('transitionend', () => {
            clearTimeout(galerieHideTimeout);
            hideLightboxEl();
        }, { once: true });

        function hideLightboxEl() {
            if (!galerieLightboxEl.classList.contains('galerieLightbox-open')) {
                galerieLightboxEl.hidden = true;
            }
        }

        document.documentElement.style.setProperty('--scrollbar-width-lockscroll', '0px');
        document.body.classList.remove('lockScroll');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.removeEventListener('touchmove', preventGalerieLightboxTouch);
        document.removeEventListener('keydown', handleGalerieLightboxKeydown);
        window.scrollTo(0, galerieSavedScrollY);

        const page = document.getElementById('page');
        if (page) {
            page.inert = false;
        }

        if (galerieLightboxTriggerEl) {
            galerieLightboxTriggerEl.focus();
            galerieLightboxTriggerEl = null;
        }
    }

    function handleGalerieLightboxKeydown(e) {
        if (e.key === 'Escape') {
            closeGalerieLightbox();
        } else if (e.key === 'ArrowLeft') {
            lhm_stepGalerieLightbox(-1);
        } else if (e.key === 'ArrowRight') {
            lhm_stepGalerieLightbox(1);
        }
    }

    window.lhm_openLightbox = openGalerieLightbox;
})();
